import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederInntektskalkulatorDto from '../Models/VeilederInntektskalkulatorDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';
import { satserReducer } from './Satser/Reducers';

const rootReducer = combineReducers<VeilederInntektskalkulatorAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederInntektskalkulatorDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederInntektskalkulatorDto>,
    ): EpiContext<VeilederInntektskalkulatorDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    satser: satserReducer,
});

export type VeilederInntektskalkulatorAppState = EpiAppStateMedSteg<VeilederInntektskalkulatorDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>;
};

export default function configureStore(): Store<VeilederInntektskalkulatorAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
